var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 8.74656C2.5 5.22813 5.191 2.36682 8.5 2.36682C11.809 2.36682 14.5 5.22813 14.5 8.74656C14.5 12.265 11.809 15.1263 8.5 15.1263C5.191 15.1263 2.5 12.265 2.5 8.74656ZM18.207 17.5644L14.812 13.9535C15.865 12.5138 16.5 10.7094 16.5 8.74656C16.5 4.05639 12.911 0.240234 8.5 0.240234C4.089 0.240234 0.5 4.05639 0.5 8.74656C0.5 13.4367 4.089 17.2529 8.5 17.2529C10.346 17.2529 12.043 16.5777 13.397 15.4581L16.793 19.0679C16.988 19.2753 17.244 19.3795 17.5 19.3795C17.756 19.3795 18.012 19.2753 18.207 19.0679C18.598 18.6522 18.598 17.9802 18.207 17.5644Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.349a2e92f7497d88257b11f1ec6c225f.svg";
export { ForwardRef as ReactComponent };